// extracted by mini-css-extract-plugin
export default {"title":"form-message_title__XokIg","description":"form-message_description__KWSPj","field":"form-message_field__ZGwHn","container":"form-message_container__NpBDi"};